<template>
  <assign-personal-panel
    ref="panel"
    :config="tabConfig"
    :users-loading="usersLoading"
  />
</template>

<script>
import AssignPersonalPanel from '../AssignPersonalPanel.vue'

const tabConfig = {
  endpoint: '/iso/follow-up-and-coordination-department-managers',
  memberPlural: 'managers',
  addTitle: 'Add follow up and coordination department manager',
  addHint: 'Select a user for the follow-up and coordination department',
  listTitle: 'Follow up and coordination department manager list',
  emptyTitle: 'No department managers yet',
  emptySearchTitle: 'No matching managers',
  emptyHint: 'Add your first follow up and coordination department manager above.',
  removeButtonTitle: 'Remove manager',
  loadError: 'Failed to load department managers',
  addError: 'Failed to add department manager',
  addSuccess: 'Department manager added successfully',
  removeTitle: 'Remove this department manager?',
  removeSuccess: 'Department manager removed',
  removeError: 'Failed to remove department manager',
}

export default {
  name: 'FollowUpManagersTab',
  components: {
    AssignPersonalPanel,
  },
  props: {
    usersLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabConfig,
    }
  },
  methods: {
    fetchMembers() {
      return this.$refs.panel?.fetchMembers()
    },
  },
}
</script>
